import { render, staticRenderFns } from "./Administraator.vue?vue&type=template&id=650d156c&"
import script from "./Administraator.vue?vue&type=script&lang=js&"
export * from "./Administraator.vue?vue&type=script&lang=js&"
import style0 from "./Administraator.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports